module.exports = __webpack_public_path__ + "250fa32c534ee6a37602db1cb69508fa.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/news-active.png
 ** module id = 1551
 ** module chunks = 0
 **/